/// <reference path="appconstants.ts" />
var EnvNgApp;
(function (EnvNgApp) {
    var Constants;
    (function (Constants) {
        var LibModuleNames;
        (function (LibModuleNames) {
            LibModuleNames.KendoDirectives = "kendo.directives";
            LibModuleNames.AngularRoute = "ngComponentRouter";
            LibModuleNames.ocLazyLoad = "oc.lazyLoad";
            LibModuleNames.AngularTranslate = "pascalprecht.translate";
            LibModuleNames.Toastr = "toastr";
            LibModuleNames.ngCookies = "ngCookies";
            LibModuleNames.ngRoute = "ngRoute";
            LibModuleNames.LoadingBar = "angular-loading-bar";
            LibModuleNames.AngularInputInterval = "angular-input-interval";
            LibModuleNames.ngWheel = "ngWheel";
            LibModuleNames.ngSanitize = "ngSanitize";
            LibModuleNames.DynamicLocale = "tmh.dynamicLocale";
        })(LibModuleNames = Constants.LibModuleNames || (Constants.LibModuleNames = {}));
    })(Constants = EnvNgApp.Constants || (EnvNgApp.Constants = {}));
})(EnvNgApp || (EnvNgApp = {}));
(function (EnvNgApp) {
    var Constants;
    (function (Constants) {
        var AngularModuleNames;
        (function (AngularModuleNames) {
            AngularModuleNames.HttpService = "$http";
            AngularModuleNames.QService = "$q";
            AngularModuleNames.Scope = "$scope";
            AngularModuleNames.Window = "$window";
            AngularModuleNames.Location = "$location";
            AngularModuleNames.Timeout = "$timeout";
            AngularModuleNames.Translate = "$translate";
            AngularModuleNames.RootScope = "$rootScope";
            AngularModuleNames.Element = "$element";
            AngularModuleNames.Filter = "$filter";
            AngularModuleNames.Document = "$document";
            AngularModuleNames.RootRouter = "$rootRouter";
            AngularModuleNames.Toastr = "toastr";
            AngularModuleNames.Cookies = "$cookies";
            AngularModuleNames.Route = "$route";
        })(AngularModuleNames = Constants.AngularModuleNames || (Constants.AngularModuleNames = {}));
    })(Constants = EnvNgApp.Constants || (EnvNgApp.Constants = {}));
})(EnvNgApp || (EnvNgApp = {}));
(function (EnvNgApp) {
    var Constants;
    (function (Constants) {
        var ViewModelModuleNames;
        (function (ViewModelModuleNames) {
            ViewModelModuleNames.ScopeInputs = "scopeInputs";
        })(ViewModelModuleNames = Constants.ViewModelModuleNames || (Constants.ViewModelModuleNames = {}));
    })(Constants = EnvNgApp.Constants || (EnvNgApp.Constants = {}));
})(EnvNgApp || (EnvNgApp = {}));
//# sourceMappingURL=modulenames.js.map